// import { useSelector } from 'react-redux'
// import { selectCurrentUser } from '../features/auth/authSlice'

// const Home = () => {
//   const user = useSelector(selectCurrentUser)
//   console.log(user);

//   return (
//     <div className="text-center py-10">
//       <h1 className="text-3xl font-bold mb-4">Welcome to Laravel React CRUD</h1>
//       {user ? (
//         <p className="text-lg">Hello, {user.UserData.name}!</p>
//       ) : (
//         <p className="text-lg">Please login or register dss</p>
//       )}
//     </div>
//   )
// }

// export default Home

import { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser, ForgotPassword, ResetPassword, fetchagentmarkup } from "../features/auth/authSlice";
import { selectAuthError, selectAuthStatus, selectCurrentUser } from "../features/auth/authSlice";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { toast } from "react-hot-toast";
import { getdomainName } from "../api/axios";
import { maskPhone } from "../utils/maskPhone";
import FooterStatic from "../components/FooterStatic";
import BlackBarScroller from "../components/BlackBarScroller";

export default function Goertrip() {
  const [activeTab, setActiveTab] = useState("login");
  const [ShowForgot, setShowForgot] = useState(false);
  const user = useSelector(selectCurrentUser);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [formDataReset, setFormDataReset] = useState({
    email: formData?.email,
    token: "",
    otp: "",
    password: "",
    password_confirmation: "",
    phone: "",
  });
  useEffect(() => {
    if (user) {
      navigate("/flight");
    }
  }, []);

  const { ForgotPasswordstatus, ForgotPasswordData, ResetPasswordstatus, ResetPasswordData } = useSelector(
    (state) => state.auth
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const status = useSelector(selectAuthStatus);
  const error = useSelector(selectAuthError);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeResetPassword = (e) => {
    setFormDataReset({
      ...formDataReset,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const resultAction = await dispatch(loginUser(formData));
      if (resultAction.payload.status) {
        toast.success("Login successfully");
        if (loginUser.fulfilled.match(resultAction)) {
          const markup = await dispatch(fetchagentmarkup());
          localStorage.setItem("agent_markup", JSON.stringify(markup.payload.data.data));
          navigate("/flight");
        }
      } else {
        toast.error(resultAction.payload.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };
  const handleforgotPassword = async (e) => {
    e.preventDefault();
    const CheckUser = {
      email: formData?.email,
    };
    if (formData.email === "") {
      toast.error("Please enter email id", { autoClose: 2000 });
      return false;
    }
    dispatch(ForgotPassword(CheckUser));
  };
  useEffect(() => {
    if (ForgotPasswordstatus === "success" && ForgotPasswordData?.status?.success === true) {
      setFormDataReset({
        ...formDataReset,
        ["email"]: formData?.email,
        ["reset_token"]: ForgotPasswordData?.token,
        ["phone"]: ForgotPasswordData?.mobile,
      });
      toast.success(ForgotPasswordData?.message, { autoClose: 2000 });
    } else if (ForgotPasswordstatus === "success" && ForgotPasswordData?.status?.success === false) {
      toast.error(ForgotPasswordData?.message, { autoClose: 2000 });
    }
  }, [ForgotPasswordData, ForgotPasswordstatus]);

  const SubmitforgotPassword = async (e) => {
    e.preventDefault();
    if (formDataReset.otp === "") {
      toast.error("Please enter OTP", { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password === "") {
      toast.error("Please new password", { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password_confirmation === "") {
      toast.error("Please password confirmation", { autoClose: 2000 });
      return false;
    }
    if (formDataReset.password_confirmation !== formDataReset.password) {
      toast.error("Please new password and confirm password not matched!", { autoClose: 2000 });
      return false;
    }

    dispatch(ResetPassword(formDataReset));
  };
  useEffect(() => {
    if (ResetPasswordstatus === "success" && ResetPasswordData?.status?.success === true) {
      toast.success(ResetPasswordData?.message, { autoClose: 2000 });
      window.location.reload();
    } else if (ResetPasswordstatus === "success" && ResetPasswordData?.status?.success === false) {
      toast.error(ResetPasswordData?.message, { autoClose: 2000 });
    }
  }, [ResetPasswordData, ResetPasswordstatus]);
  return (
    <>
      <div className="min-h-screen bg-white">
        <section
          className="flex flex-col md:flex-row justify-between items-center text-white relative overflow-hidden"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px))",
            backgroundColor: "#2600ff",
          }}
        >
          {/* Left */}
          <div className="md:w-1/2 space-y-6 p-12">
            <div className="bg-white/10 w-12 h-12 flex items-center justify-center rounded-xl">✈️</div>
            <h1 className="text-4xl font-bold leading-tight">
              Your Gateway to Effortless Flight Booking <br className="hidden md:block" />
              and Unbeatable Travel Deals!
            </h1>
            <p className="text-white max-w-md">
              From exclusive fares and rewards to the freedom of booking now and paying later – Goertrip makes every
              journey smarter and easier.
            </p>
            <button className="px-6 py-3 rounded-full bg-blue-600 hover:bg-blue-700 font-medium transition">
              Getting Started
            </button>
            {/* App Store buttons */}
            <div className="flex space-x-4 pt-6">
              <a href="https://apps.apple.com/us/app/goertrip/id6741723959" target="_blanck">
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="App Store"
                  className="h-12"
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.catpl.goertrip" target="_blanck">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Google Play"
                  className="h-12"
                />
              </a>
            </div>
          </div>
          {/* Right Login Card */}
          {/* Right Login Card */}
          <div className="md:w-1/2 max-w-md mt-12 md:mt-0 bg-[#1a1f27]/90 backdrop-blur-xl rounded-3xl p-10 shadow-2xl border border-white/10 relative">
            {/* Glow Border Accent */}
            <div className="absolute inset-0 rounded-3xl border-2 border-transparent [background:linear-gradient(135deg,#ffffff,#ffffff)_padding-box,linear-gradient(135deg,#ffffff,#ffffff)_border-box]"></div>
            {/* Content Wrapper */}
            <div className="relative z-10">
              {/* Tabs */}
              <div className="flex mb-6 border-b border-gray-700">
                <button className="pb-2 border-b-2 border-blue-500 font-semibold text-blue-600">Login</button>
                <a className="pb-2 ml-8 text-blue-600 hover:text-blue-600" href={"/register"}>
                  Registration
                </a>
              </div>
              {/* Partner / Supplier Switch */}
              <div className="flex bg-[#2600ff] rounded-full p-1 mb-6">
                <button className="w-1/2 py-2 rounded-full bg-white text-black font-medium">Partner</button>
                <button className="w-1/2 py-2 rounded-full text-gray-300">Supplier</button>
              </div>
              {/* Tagline */}

              {!ShowForgot && (
                <form className="space-y-4" onSubmit={handleSubmit}>
                  <p className="text-md text-blue-600 mb-4">Welcome back! Please log in to continue 🚀</p>
                  <div>
                    <label className="text-blue-600 text-md">Email</label>
                    <div className="flex items-center bg-[#2600ff] rounded-full px-4 py-3 mt-1 focus-within:ring-2 focus-within:ring-blue-500">
                      <span className="text-blue-600 mr-2">📧</span>
                      <input
                        type="email"
                        placeholder="Enter your registered email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full bg-[#2600ff] autofill-white outline-none text-white placeholder-white"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="text-blue-600 text-md">Password</label>
                    <div className="flex items-center bg-[#2600ff] rounded-full px-4 py-3 mt-1 focus-within:ring-2 focus-within:ring-blue-500">
                      <span className="text-blue-600 mr-2">🔒</span>
                      <input
                        type="password"
                        placeholder="Enter your password"
                        name="password"
                        required
                        value={formData.password}
                        onChange={handleChange}
                        className="w-full bg-[#2600ff] outline-none text-white autofill-white placeholder-white"
                      />
                    </div>
                  </div>
                  <div className="flex justify-between items-center text-sm text-blue-600">
                    <label className="flex items-center space-x-2">
                      <input type="checkbox" className="accent-blue-600" />
                      <span>Remember me?</span>
                    </label>
                    <a onClick={() => setShowForgot(!ShowForgot)} className="hover:text-blue-600 cursor-pointer">
                      Forgot Password?
                    </a>
                  </div>
                  {/* <button type="submit" className="w-full py-3 rounded-full bg-[#2600ff] from-blue-600 to-cyan-500 hover:opacity-90 font-medium text-white transition shadow-lg shadow-blue-500/30">
                    Login
                  </button> */}
                  <button
                    type="submit"
                    disabled={status === "loading"}
                    className="w-full py-3 rounded-full bg-[#2600ff] from-blue-600 to-cyan-500 hover:opacity-90 font-medium text-white transition shadow-lg shadow-blue-500/30"
                  >
                    {status === "loading" ? "Logging in..." : "Login"}
                  </button>
                </form>
              )}

              {ShowForgot && (
                <>
                  {ForgotPasswordstatus !== "success" && (
                    <form className="space-y-4" onSubmit={handleforgotPassword}>
                      <div>
                        <label className="text-blue-600 text-md">Email</label>
                        <div className="flex items-center bg-[#2600ff] rounded-full px-4 py-3 mt-1 focus-within:ring-2 focus-within:ring-blue-500">
                          <span className="text-blue-600 mr-2">📧</span>
                          <input
                            type="email"
                            placeholder="Enter your registered email"
                            name="email"
                            required
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full bg-[#2600ff] autofill-white outline-none text-white placeholder-white"
                          />
                        </div>
                      </div>

                      <div className="flex justify-between items-center text-sm text-blue-600">
                        <a onClick={() => setShowForgot(!ShowForgot)} className="hover:text-blue-600 cursor-pointer">
                          Login?
                        </a>
                      </div>
                      <button
                        type="submit"
                        disabled={ForgotPasswordstatus === "pendig"}
                        className="w-full py-3 rounded-full bg-[#2600ff] from-blue-600 to-cyan-500 hover:opacity-90 font-medium text-white transition shadow-lg shadow-blue-500/30"
                      >
                        {ForgotPasswordstatus === "pendig" ? "Please wait..." : "Submit"}
                      </button>
                    </form>
                  )}

                  {ForgotPasswordstatus === "success" && (
                    <form className="space-y-4" onSubmit={SubmitforgotPassword}>
                      <div>
                        <label className="text-blue-600 text-md">Enter OTP</label>
                        <div className="flex items-center bg-[#2600ff] rounded-full px-4 py-3 mt-1 focus-within:ring-2 focus-within:ring-blue-500">
                          <span className="text-blue-600 mr-2">🔒</span>
                          <input
                            type="number"
                            placeholder="Enter OTP"
                            required
                            name="otp"
                            value={formDataReset.otp}
                            onChange={handleChangeResetPassword}
                            className="w-full bg-[#2600ff] autofill-white outline-none autofill-white text-white placeholder-white"
                          />
                        </div>
                      </div>
                      <div>
                        <label className="text-blue-600 text-md"> New Password</label>
                        <div className="flex items-center bg-[#2600ff] rounded-full px-4 py-3 mt-1 focus-within:ring-2 focus-within:ring-blue-500">
                          <span className="text-blue-600 mr-2">🔒</span>
                          <input
                            type="password"
                            placeholder="Enter New Password"
                            name="password"
                            required
                            value={formDataReset.password}
                            onChange={handleChangeResetPassword}
                            className="w-full bg-[#2600ff] outline-none text-white autofill-white placeholder-white"
                          />
                        </div>
                      </div>
                      <div>
                        <label className="text-blue-600 text-md">Confirmed Password</label>
                        <div className="flex items-center bg-[#2600ff] rounded-full px-4 py-3 mt-1 focus-within:ring-2 focus-within:ring-blue-500">
                          <span className="text-blue-600 mr-2">🔒</span>
                          <input
                            type="password"
                            placeholder="Enter Confirmed password"
                            name="password_confirmation"
                            required
                            value={formDataReset.password_confirmation}
                            onChange={handleChangeResetPassword}
                            className="w-full bg-[#2600ff] outline-none text-white autofill-white placeholder-white"
                          />
                        </div>
                      </div>
                      <small className="text-sm text-blue-600 text-right">
                        OTP has been shared with your mobile ending in {maskPhone(formDataReset?.phone, 2)}
                      </small>
                      <div className="flex justify-between items-center text-sm text-blue-600">
                        <a onClick={() => setShowForgot(!ShowForgot)} className="hover:text-blue-600 cursor-pointer">
                          Login?
                        </a>
                      </div>
                      <button
                        type="submit"
                        disabled={ResetPasswordstatus === "pendig"}
                        className="w-full py-3 rounded-full bg-[#2600ff] from-blue-600 to-cyan-500 hover:opacity-90 font-medium text-white transition shadow-lg shadow-blue-500/30"
                      >
                        {ResetPasswordstatus === "pendig" ? "Please wait..." : "Submit"}
                      </button>
                    </form>
                  )}
                </>
              )}
            </div>
          </div>
        </section>

        <BlackBarScroller />

        <section className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center py-16 bg-white">
          <div>
            <p className="text-3xl font-bold">100K+</p>
            <p className="text-gray-600">Trusted Travellers</p>
          </div>
          <div>
            <p className="text-3xl font-bold">50K</p>
            <p className="text-gray-600">Users Downloads</p>
          </div>
          <div>
            <p className="text-3xl font-bold">4.5★</p>
            <p className="text-gray-600">Rating on Google Play</p>
          </div>
        </section>

        <FooterStatic />
      </div>
    </>
  );
}
